export default "__VITE_ASSET__59cf93b4__"